(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('cpUiFunctions', ["feature", "autologinHelper", function (feature, autologinHelper) {
        var cpUiFunctions = {
            isCpUI: function () {
                if (autologinHelper.enabled()) {
                    return true;
                } else {
                    return false;
                }
            },
            isCpCustomer: function () {
                if (feature.checkpointTheme) {
                    return true;
                } else {
                    return false;
                }
            },
            createCPLoadPageUrl: function (portalUrl, api) {
                if (!portalUrl) {
                    return api;
                }
                if (cpUiFunctions.isCpUI()) {
                    return portalUrl + '?route=' + encodeURIComponent(window.btoa('/new.html#!/loadPage' + api));
                } else {
                    return api;
                }
            }
        };
        return cpUiFunctions;
    }]);
}());